import React, { useEffect, useState } from 'react';

import cn from 'classnames';

import { useDebounce } from 'hooks/useDebounce/useDebounce';
import { SelectCommunitiesType } from 'hooks/useSelectCommunities/useSelectCommunities';
import { Select } from 'ui-kit';

import './CommunitiesSelect.scss';

type CommunitiesSelectType = {
  selectCommunities: SelectCommunitiesType;
  className?: string;
};

export const CommunitiesSelect = ({
  className,
  selectCommunities,
}: CommunitiesSelectType) => {
  const {
    selectOptions,
    onChangeSelect,
    onFocusSelect,
    onInputChangeSelect,
    selectedValue,
    onMenuScrollToBottom,
  } = selectCommunities;

  const [inputValue, setInputValue] = useState<string>('');
  const debouncedInputValue = useDebounce(inputValue, 500);

  useEffect(() => {
    onInputChangeSelect(debouncedInputValue);
  }, [debouncedInputValue, onInputChangeSelect]);

  return (
    <Select
      onFocus={onFocusSelect}
      isSearchSelect
      placeholder="Find community"
      options={selectOptions}
      isMulti
      value={selectedValue}
      onChange={value => onChangeSelect(value)}
      onInputChange={(value, actionMeta) => {
        if (actionMeta?.action === 'input-blur' || actionMeta?.action === 'menu-close')
          return;
        setInputValue(value);
      }}
      className={cn('CommunitiesSelect', className)}
      onMenuScrollToBottom={onMenuScrollToBottom}
    />
  );
};
